import { render, staticRenderFns } from "./ReservationMediaAdd.vue?vue&type=template&id=c8b8032c&scoped=true&"
import script from "./ReservationMediaAdd.vue?vue&type=script&lang=js&"
export * from "./ReservationMediaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b8032c",
  null
  
)

export default component.exports